import _ from 'lodash';

/**
 * Ephemeral editor draft for pay → download (survives Lemon redirect remount).
 * sessionStorage only — not used as long-term recover storage.
 */

const EDITOR_DRAFT_KEY = 'ledscroller_editor_draft_v1';

// Persist current LED editor fields before checkout
export const saveEditorDraft = (draft) => {
  try {
    const name = String(_.get(draft, 'name', '') || '').trim();
    if (!name) {
      return false;
    }
    const payload = {
      name,
      color: _.get(draft, 'color', '#ffffff'),
      bgColor: _.get(draft, 'bgColor', '#000000'),
      speed: Number(_.get(draft, 'speed', 30)) || 30,
      fontSize: Number(_.get(draft, 'fontSize', 85)) || 85,
      isblink: !!_.get(draft, 'isblink', true),
      blinkSpeed: Number(_.get(draft, 'blinkSpeed', 30)) || 30,
      isFlipText: !!_.get(draft, 'isFlipText', false),
      savedAt: Date.now(),
    };
    sessionStorage.setItem(EDITOR_DRAFT_KEY, JSON.stringify(payload));
    return true;
  } catch (e) {
    return false;
  }
};

// Read draft; returns null if missing/invalid
export const loadEditorDraft = () => {
  try {
    const raw = sessionStorage.getItem(EDITOR_DRAFT_KEY);
    if (!raw) {
      return null;
    }
    const parsed = JSON.parse(raw);
    const name = String(_.get(parsed, 'name', '') || '').trim();
    if (!name) {
      return null;
    }
    return {
      name,
      color: _.get(parsed, 'color', '#ffffff'),
      bgColor: _.get(parsed, 'bgColor', '#000000'),
      speed: Number(_.get(parsed, 'speed', 30)) || 30,
      fontSize: Number(_.get(parsed, 'fontSize', 85)) || 85,
      isblink: !!_.get(parsed, 'isblink', true),
      blinkSpeed: Number(_.get(parsed, 'blinkSpeed', 30)) || 30,
      isFlipText: !!_.get(parsed, 'isFlipText', false),
    };
  } catch (e) {
    return null;
  }
};

// Prefer live text; fall back to session draft (pay→download after remount)
export const resolveEditorText = (liveName) => {
  const live = String(liveName || '').trim();
  if (live) {
    return live;
  }
  const draft = loadEditorDraft();
  return String(_.get(draft, 'name', '') || '').trim();
};

// Clear after successful paid download only
export const clearEditorDraft = () => {
  try {
    sessionStorage.removeItem(EDITOR_DRAFT_KEY);
  } catch (e) {
    // ignore
  }
};

export default {
  saveEditorDraft,
  loadEditorDraft,
  resolveEditorText,
  clearEditorDraft,
};
